import React, {Component} from 'react';
import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import {Table, Icon, Dimmer, Loader} from 'semantic-ui-react';
import {INVOICING_FORM} from '../../../../common/forms';
import ManualTableBody from './manualTableBody';

class ManualTable extends Component {
  getTextForLoader() {
    const {savingLineInfo, deleting, invoicing} = this.props;
    if (savingLineInfo || invoicing) {
      return 'Guardando';
    }
    if (deleting) {
      return 'Eliminando';
    }
    return 'Cargando';
  }
  
  addItem(fields) {
    fields.push({'partCode': '', 'partCodeCkecked': false});
  }

  renderLoader() {
    const {loadingClients, loadingWarehouses, loadingManualsOrders, savingLineInfo, deleting, invoicing} = this.props;
    const isDisabled = loadingClients || loadingWarehouses || loadingManualsOrders ||
    savingLineInfo || deleting || invoicing;
    if (!isDisabled) {
      return null;
    }

    const textToShow = this.getTextForLoader();
    return (
      <Dimmer active inverted>
        <Loader inverted content={textToShow} />
      </Dimmer>
    );
  }

  render() {
    const {fields} = this.props;
    const allItems = fields.getAll() || [];
    return (
      <div>
        {this.renderLoader()}
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Cod Parte</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad Requerida</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad Disponible</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Precio de venta</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Subtotal</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <ManualTableBody {...this.props} allItems={allItems}/>
        </Table>
        
        <div className='addItem' onClick={() => this.addItem(fields)}>
          <Icon name='add' />
          <strong>AGREGAR REGISTRO</strong>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(INVOICING_FORM.name);
  const items = formValues(state, 'items');

  return {
    items,
    'loadingManualsOrders': state.invoicing.loading,
    'savingLineInfo': state.invoicing.savingLineInfo,
    'deleting': state.invoicing.deleting,
    'invoicing': state.invoicing.invoicing,
  };
};

export default connect(mapStateToProps, {})(ManualTable);
